// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Handle-style__root__oEp1h{font-weight:700}.components-Handle-style__link__PM7tP{color:#007dff}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `components-Handle-style__root__oEp1h`,
	"link": `components-Handle-style__link__PM7tP`
};
export default ___CSS_LOADER_EXPORT___;
